import client from "../Client/HttpClient";
import { IAcademicYearModel } from "@/interfaces/modules";
const ApiPath = "AcademicYear";

export default {
    GetAcademicYears: (): Promise<IAcademicYearModel[]> => client.get(`${ApiPath}`),
    GetAcademicYearById: (data: { Id: number }): Promise<IAcademicYearModel> => client.get(`${ApiPath}/${data.Id}`),
    PostAcademicYear: (data: IAcademicYearModel): Promise<IAcademicYearModel> => client.post(`${ApiPath}`, data)
};
